import { findFirstError, handleErrors } from '@/shared/lib/errors';

import { API_URLS, apiWrapper } from '@/shared/api/main';

import { IErrorResponseData } from '@/shared/types/error';

export interface ICreateFeedbackPayload {
  text: string;
  url: string;
  browser: string;
  screen_resolution: string;
  /** Источник сообщения; веб всегда шлёт 'web', 'mobile' — за мобильным приложением */
  source: 'web' | 'mobile';
  screenshot?: File;
}

/**
 * Отправка сообщения обратной связи
 * @param payload - данные сообщения
 * @param payload.text - комментарий пользователя
 * @param payload.url - адрес страницы, с которой отправлено сообщение
 * @param payload.browser - user-agent браузера
 * @param payload.screen_resolution - разрешение экрана и вьюпорта
 * @param payload.source - источник сообщения (web / mobile)
 * @param payload.screenshot - скриншот экрана с рамками-выделениями
 */
export const createFeedback = async (payload: ICreateFeedbackPayload) => {
  const response = await apiWrapper.post<unknown, IErrorResponseData>(
    API_URLS.feedbacks,
    { feedback: payload },
    { headers: { 'Content-Type': 'multipart/form-data' } }
  );

  if (!response.ok) {
    // 422 приходит как `{ feedback: { errors: { поле: [текст] } } }` — показываем готовую
    // фразу бэка вместо «Неизвестная ошибка»
    const { mainError, modelErrors } = handleErrors(response, 'feedback');
    const modelError = modelErrors ? findFirstError(modelErrors) : null;

    throw new Error(modelError ?? mainError);
  }

  return response.data || ({} as unknown);
};
